import { thumbProps as N } from "./index672.js";
import { defineComponent as A, inject as O, ref as m, computed as E, onBeforeUnmount as j, toRef as H, openBlock as K, createBlock as U, Transition as W, unref as v, withCtx as I, withDirectives as V, createElementVNode as L, withModifiers as q, normalizeClass as M, normalizeStyle as F, vShow as G } from "vue";
import { useEventListener as x } from "./index562.js";
import { scrollbarContextKey as J } from "./index673.js";
import { BAR_MAP as Q, renderThumbStyle as X } from "./index670.js";
import { useNamespace as Y } from "./index559.js";
import { throwError as Z } from "./index588.js";
import { isClient as $ } from "./index599.js";
const ee = "Thumb";
var ce = /* @__PURE__ */ A({
  __name: "thumb",
  props: N,
  setup(g) {
    const s = g, o = O(J), u = Y("scrollbar");
    o || Z(ee, "can not inject scrollbar context");
    const n = m(), a = m(), f = m({}), c = m(!1);
    let i = !1, d = !1, w = 0, S = 0, p = $ ? document.onselectstart : null;
    const e = E(() => Q[s.vertical ? "vertical" : "horizontal"]), z = E(
      () => X({
        size: s.size,
        move: s.move,
        bar: e.value
      })
    ), C = E(
      () => (
        // offsetRatioX = original width of thumb / current width of thumb / ratioX
        // offsetRatioY = original height of thumb / current height of thumb / ratioY
        // instance height = wrap height - GAP
        n.value[e.value.offset] ** 2 / o.wrapElement[e.value.scrollSize] / s.ratio / a.value[e.value.offset]
      )
    ), _ = (t) => {
      var l;
      if (t.stopPropagation(), t.ctrlKey || [1, 2].includes(t.button)) return;
      (l = window.getSelection()) == null || l.removeAllRanges(), R(t);
      const r = t.currentTarget;
      r && (f.value[e.value.axis] = r[e.value.offset] - (t[e.value.client] - r.getBoundingClientRect()[e.value.direction]));
    }, B = (t) => {
      if (!a.value || !n.value || !o.wrapElement) return;
      const l = Math.abs(
        t.target.getBoundingClientRect()[e.value.direction] - t[e.value.client]
      ), r = a.value[e.value.offset] / 2, h = (l - r) * 100 * C.value / n.value[e.value.offset];
      o.wrapElement[e.value.scroll] = h * o.wrapElement[e.value.scrollSize] / 100;
    }, R = (t) => {
      t.stopImmediatePropagation(), i = !0, w = o.wrapElement.scrollHeight, S = o.wrapElement.scrollWidth, document.addEventListener("mousemove", P), document.addEventListener("mouseup", b), p = document.onselectstart, document.onselectstart = () => !1;
    }, P = (t) => {
      if (!n.value || !a.value || i === !1) return;
      const l = f.value[e.value.axis];
      if (!l) return;
      const r = (n.value.getBoundingClientRect()[e.value.direction] - t[e.value.client]) * -1, h = a.value[e.value.offset] - l, y = (r - h) * 100 * C.value / n.value[e.value.offset];
      e.value.scroll === "scrollLeft" ? o.wrapElement[e.value.scroll] = y * S / 100 : o.wrapElement[e.value.scroll] = y * w / 100;
    }, b = () => {
      i = !1, f.value[e.value.axis] = 0, document.removeEventListener("mousemove", P), document.removeEventListener("mouseup", b), k(), d && (c.value = !1);
    }, T = () => {
      d = !1, c.value = !!s.size;
    }, D = () => {
      d = !0, c.value = i;
    };
    j(() => {
      k(), document.removeEventListener("mouseup", b);
    });
    const k = () => {
      document.onselectstart !== p && (document.onselectstart = p);
    };
    return x(
      H(o, "scrollbarElement"),
      "mousemove",
      T
    ), x(
      H(o, "scrollbarElement"),
      "mouseleave",
      D
    ), (t, l) => (K(), U(W, {
      name: v(u).b("fade"),
      persisted: ""
    }, {
      default: I(() => [
        V(L(
          "div",
          {
            ref_key: "instance",
            ref: n,
            class: M([v(u).e("bar"), v(u).is(e.value.key)]),
            onMousedown: B,
            onClick: l[0] || (l[0] = q(() => {
            }, ["stop"]))
          },
          [
            L(
              "div",
              {
                ref_key: "thumb",
                ref: a,
                class: M(v(u).e("thumb")),
                style: F(z.value),
                onMousedown: _
              },
              null,
              38
              /* CLASS, STYLE, NEED_HYDRATION */
            )
          ],
          34
          /* CLASS, NEED_HYDRATION */
        ), [
          [G, g.always || c.value]
        ])
      ]),
      _: 1
      /* STABLE */
    }, 8, ["name"]));
  }
});
export {
  ce as default
};
